// extracted by mini-css-extract-plugin
export default {"input":"PhoneInput_input__Gmptf"};